import AppPaths from '@globals/paths'
import { Navigate, useLocation } from 'react-router'

const DesklessRedirectActivateToSignup = () => {
  const { search } = useLocation()
  return <Navigate to={{ pathname: AppPaths.anon.desklessSignup(), search }} />
}

export default DesklessRedirectActivateToSignup
